export default "/images/vendor/flag-icon-css/flags/4x3/pa.svg?8659812291825552ed13c277d78a8968";